"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandDeepLink = exports.getRBIDomain = exports.BrandDeepLinkPrefix = void 0;
__exportStar(require("./generated/domains"), exports);
var BrandDeepLinkPrefix;
(function (BrandDeepLinkPrefix) {
    BrandDeepLinkPrefix["BK"] = "burgerking://";
    BrandDeepLinkPrefix["LTW"] = "ltw://";
    BrandDeepLinkPrefix["PLK"] = "popeyes://";
    BrandDeepLinkPrefix["TH"] = "timhortons://";
    BrandDeepLinkPrefix["FHS"] = "firehousesubs://";
})(BrandDeepLinkPrefix = exports.BrandDeepLinkPrefix || (exports.BrandDeepLinkPrefix = {}));
/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */
const getRBIDomain = (brand, stage, locale) => {
    const normalizedLocale = (locale.region || '').toLowerCase();
    if (!normalizedLocale) {
        throw new Error(`Unsupported country code ${normalizedLocale}`);
    }
    return `${stage}-${brand.toLowerCase()}-${normalizedLocale}-web.rbi.tools`;
};
exports.getRBIDomain = getRBIDomain;
/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */
const getBrandDeepLink = ({ brand }) => {
    return BrandDeepLinkPrefix[brand];
};
exports.getBrandDeepLink = getBrandDeepLink;
//# sourceMappingURL=domains.js.map